/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Deleted_WarningInputs */

const vi_einvoice_deleted_warning = /** @type {(inputs: Einvoice_Deleted_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hóa đơn đã bị xóa hoặc hủy trên MISA. File chỉ dùng để xem lịch sử.`)
};

/**

* @param {Einvoice_Deleted_WarningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_deleted_warning = /** @type {((inputs?: Einvoice_Deleted_WarningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Deleted_WarningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_deleted_warning(inputs)
});